import { css } from 'emotion';

const modal = css`
  .MuiPaper-root {
    @media (min-width: 1600px) {
      width: 900px;
    }

    @media (max-width: 1600px) {
      width: 720px;
    }
  }
`;

export default {
  modal,
};
